// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__Yi2mK","secondary":"button_secondary__3I0Zz","tertiary":"button_tertiary___Uh4_","primary":"button_primary__Ef0_P","danger":"button_danger__2gwnL"};